import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinancialDataIntegrationStep = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0.75) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.98167 11.3192H2.0675M4.2025 7.405H1M5.98167 3.49083H2.42333M11.675 1L6.98054 7.57225C6.77276 7.86314 6.66887 8.00859 6.67336 8.12985C6.67728 8.23543 6.7279 8.33381 6.81154 8.39836C6.9076 8.4725 7.08634 8.4725 7.44382 8.4725H10.9633L10.2517 13.81L14.9461 7.23775C15.1539 6.94686 15.2578 6.80141 15.2533 6.68015C15.2494 6.57457 15.1988 6.47619 15.1151 6.41164C15.0191 6.3375 14.8403 6.3375 14.4828 6.3375H10.9633L11.675 1Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgFinancialDataIntegrationStep);
export default ForwardRef;
